// Groups a flat list of {title, rowNumber} items into ordered rows. The API
// uses rowNumber to say which items belong on the same visual row at a given
// level (e.g. Books/Info/Stationary/Bundles all rowNumber 1, but Read/Unread
// sit on rowNumber 3 alongside their own siblings) - items must be split into
// one row per distinct rowNumber rather than flattened into a single row,
// otherwise unrelated groups end up wrapped together.
export function groupByRowNumber(items) {
  const rows = new Map();

  items.forEach((item) => {
    const rowNumber = item.rowNumber || 1;
    if (!rows.has(rowNumber)) rows.set(rowNumber, []);
    rows.get(rowNumber).push(item);
  });

  return Array.from(rows.entries())
    .sort(([a], [b]) => a - b)
    .map(([rowNumber, rowItems]) => ({ rowNumber, items: rowItems }));
}
